'use client';

import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { AppSidebarFooter } from '@owlcat/app-shell';
import { PortalHeaderControls } from '@/contexts/application/components/layout/PortalHeaderControls';

interface SidebarFooterProps {
  onCloseMobileMenu: () => void;
}

/** Browser-reachable accounts origin — the canonical legal SoT. */
const accountsBase = (process.env.NEXT_PUBLIC_ACCOUNTS_URL || 'http://127.0.0.1:3200').replace(/\/+$/, '');

/**
 * Portal's sidebar footer — the shared <AppSidebarFooter> chrome. Subscription
 * is NOT a separate slot here: the hidden-tokens allowance % lives inside
 * <PortalHeaderControls> (as the profile-cluster meter), so we pass only the
 * profile + support + the accounts legal links.
 */
export function SidebarFooter({ onCloseMobileMenu }: SidebarFooterProps) {
  const t = useTranslations('common');

  // `return` = the current portal URL so accounts /info/* can render a "← Back"
  // button. Read window ONLY after mount (avoids a hydration mismatch); accounts
  // open-redirect-guards the value regardless.
  const [ret, setRet] = useState('');
  useEffect(() => {
    setRet(window.location.href);
  }, []);
  const info = (path: string) =>
    ret ? `${accountsBase}${path}?return=${encodeURIComponent(ret)}` : `${accountsBase}${path}`;

  return (
    <AppSidebarFooter
      profile={<PortalHeaderControls />}
      support={{ label: t('support') }}
      legal={{
        privacyUrl: info('/info/privacy'),
        termsUrl: info('/info/terms'),
        labels: { privacy: t('privacy'), cookies: t('cookies'), terms: t('terms') },
      }}
      onNavigate={onCloseMobileMenu}
    />
  );
}
